import { render } from "./LicenceHistory.vue?vue&type=template&id=409a6d9e"
import script from "./LicenceHistory.vue?vue&type=script&lang=js"
export * from "./LicenceHistory.vue?vue&type=script&lang=js"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__